import { useLocation } from "react-router-dom";

export const useCheckLocation = () => {
  const location = useLocation();
  const isFormLocation = location.pathname.endsWith("/form");

  return { isFormLocation };
};
